<script setup lang="ts">
    // @ts-nocheck
    import { getConfig, getErrorMessage, klinikenApi } from "@/api";
    import KButton from "@/components/Button.vue";
    import KButtonGroup from "@/components/ButtonGroup.vue";
    import { useStore } from "@/store";
    import { flashMessage, openDialog } from "@/utils";
    import { openNLLErrorDialog } from "@/tabs/Receptforskrivning/helpers";

    const store = useStore();

    const emit = defineEmits(["close"]);

    const submit = async () => {
        try {
            const data = {
                patient: store.state.patientData.currentId,
                status: "proposed",
            };
            const response = await klinikenApi.post(
                "/nll/samtycken/create/",
                data,
                getConfig({
                    headers: store.getters["nll/headers"],
                })
            );

            store.commit("nll/setConsentRequest", { consentRequest: response.data.status });

            flashMessage("Förfrågan om registrerat åtkomstsamtycke skickad");

            emit("close");
        } catch (error: any) {
            openNLLErrorDialog({ error, description: "Det gick inte att skicka samtyckesförfrågan." });

            emit("close");
        }
    };

    const cancel = () => {
        emit("close");
    };
</script>

<template>
    <div class="skicka-samtyckesforfragan">
        <p class="info">
            Du vill skicka en förfrågan om registrerat åtkomstsamtycke till patienten. Om patienten godkänner i
            Läkemedelskollen skapas ett registrerat åtkomstsamtycke.
        </p>
        <KButtonGroup>
            <KButton @click="submit" size="secondary">Skicka förfrågan</KButton>
            <KButton @click="cancel" size="slim" variant="contour">Avbryt</KButton>
        </KButtonGroup>
    </div>
</template>

<style lang="scss">
    .skicka-samtyckesforfragan {
        .info-header {
            margin-bottom: 1.5rem;
        }

        .info {
            margin-bottom: 1.5rem;
        }
    }
</style>
